export default __webpack_public_path__ + "static/media/img_xml.65ef0fa0.svg";